import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import history from '../../../../../history';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import akmApi from '../../../../../apis/akmApi';


import { Row, Col } from 'react-bootstrap';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,FormControl,InputLabel,Input,FormControlLabel, Checkbox, Button, Typography, Grid} from '@material-ui/core';
import PaginationTable from '../../masterDropDown/PaginationTable';
import PaginationData from '../../../../../entity/PaginationData';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class ListAllJadwalProfilCbt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            showAlert: false,
            namaJadwalCbt: "",
            listJadwalProgramHub: [],
            listKelasGroup: [],
            paginationData: PaginationData,
            detailPaketProgram: props.detailPaketProgram,
            isOpen : false,
        }
    }

    async componentDidMount(){
        this.fetchJadwalProgramHub("");
    }

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleCloseModal = async () =>{
        this.setState({isOpen : false});
    }

    fetchJadwalProgramHub = async (namaJadwalCbt) =>{
        this.setState({ isFetching: true });
        this.props.handleIsFetching(true);

        const {detailPaketProgram} = this.state;
        const result = await akmApi.post(URL_AKM.FETCH_PAKET_PROGRAM_HUB+'?page='+this.state.paginationData.page+'&size='+this.state.paginationData.size+"&idPaketProgram="+detailPaketProgram.idPaketProgram, {
            "namaJadwalCbt": namaJadwalCbt
        })
        if(result){
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    showAlert: false,
                    listJadwalProgramHub: result.data.data.content,
                    paginationData: {...this.state.paginationData, 
                        page: result.data.data.number,
                        size: result.data.data.size,
                        totalPages: result.data.data.totalPages,
                        numberOfElements: result.data.data.numberOfElements,
                        totalElements: result.data.data.totalElements
                    }
                })
            } else {
                this.setState({
                    listJadwalProgramHub: [],
                    paginationData:PaginationData,
                    showAlert: true,
                    resMessage: result.data.errorSchema.errorMessage    
                })
            }
        }
        this.setState({ isFetching: false });
        this.props.handleIsFetching(false);
    }

    handleChangePage = async(newPage) => {
        this.state.paginationData.page = newPage;
        this.fetchJadwalProgramHub(this.state.namaJadwalCbt);
    }

    handleChangeRowsPerPage = (size) => {
        this.state.paginationData.page = 0;
        this.state.paginationData.size = size;
        this.fetchJadwalProgramHub(this.state.namaJadwalCbt);
    }

    formatDate(s){
        var options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(s).toLocaleTimeString([],options);
    }
    
    handleChangeNameJadwal= async (e) =>{
        const id = e.target.id;
        const val = e.target.value;
        this.setState({'namaJadwalCbt': val});
        this.fetchJadwalProgramHub(val);
    }

    handleChangeCheckbox = async (idJadwalProgramHub, idJadwalProfilCbt, idPaketProgram) =>{
        this.props.handleIsFetching(true);
        var result ="";
        console.groupCollapsed('SEND CHECKBOX');
        console.info('namaJadwalCbt', this.state.namaJadwalCbt);
        console.info('idJadwalProgramHub', idJadwalProgramHub);
        console.info('idJadwalProfilCbt', idJadwalProfilCbt);
        console.info('idPaketProgram', idPaketProgram);
        console.groupEnd();

        if(idJadwalProgramHub > 0){
            result = await akmApi.delete(URL_AKM.SAVE_DELETE_PAKET_PROGRAM_HUB + idJadwalProgramHub)

        }else{
            result = await akmApi.post(URL_AKM.SAVE_DELETE_PAKET_PROGRAM_HUB, {
                "idPaketProgram": idPaketProgram,
                'idJadwalProfilCbt': idJadwalProfilCbt
            })
        }
        if(result){
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    showAlert: false,
                })
            } else {
                this.setState({
                    showAlert: true,
                    resMessage: result.data.errorSchema.errorMessage    
                })
            }
        }

        this.fetchJadwalProgramHub(this.state.namaJadwalCbt);

    }

    render() { 
        const {paginationData, showAlert, resMessage} = this.state;
        return (
            <>
                <Grid container 
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    spacing={3}>

                    <Grid item xs={12} sm={6} lg={9}>
                    <   Button variant="outlined" color="secondary" onClick={() => history.push({pathname:"/mgtpp"})}>
                            <ArrowBackIosIcon fontSize="small"/>Back
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <FormControl>
                            
                            <InputLabel htmlFor="standard-adornment-password">
                                {showAlert ?
                                        <Typography variant="body1" color="error">{resMessage}</Typography>
                                    :
                                        <Typography variant="body1" color="textPrimary">Cari Nama Jadwal</Typography>
                                }
                            </InputLabel>
                            <Input
                                onChange={this.handleChangeNameJadwal}
                                placeholder="Cari Nama Jadwal"
                                id="namaJadwalCbt"
                                endAdornment={<SearchIcon position="end" />}
                            />
                        </FormControl>
                    </Grid>

                </Grid>
                <Row style={{marginTop: 25}}>
                    <Col>
                        <TableContainer component={Paper}>                    
                            <Table aria-label="collapsible table">
                                <TableHead>
                                <TableRow>
                                    <TableCell align="left">Nama Jadwal</TableCell>
                                    <TableCell align="left">Jadwal Mulai</TableCell>
                                    <TableCell align="left">Jadwal Selesai</TableCell>
                                    <TableCell align="left">Jadwalkan</TableCell>
                                    <TableCell />
                                </TableRow>
                                </TableHead>
                                {this.renderRow()}
                            </Table>
                            <PaginationTable paging={paginationData} handleChangePage={this.handleChangePage} handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
                        </TableContainer>
                        
                    </Col>
                </Row>
            </>
        );
    }

    renderRow(){
        const {listJadwalProgramHub, detailPaketProgram} = this.state;
        var nf = new Intl.NumberFormat();
        return(
            <TableBody>
                {!__.isEmpty(listJadwalProgramHub) &&
                    listJadwalProgramHub.map((jadwalHub, i)=>
                        <TableRow key={i}>
                            <TableCell>{jadwalHub.namaJadwal}</TableCell>
                            <TableCell>{this.formatDate(jadwalHub.startDate)}</TableCell>
                            <TableCell>{this.formatDate(jadwalHub.expiredDate)}</TableCell>
                            <TableCell align="center">
                                <FormControlLabel
                                    control=
                                        {<Checkbox 
                                            checked={jadwalHub.idJadwalProgramHub > 0 ? true : false} 
                                            onClick={() => this.handleChangeCheckbox(jadwalHub.idJadwalProgramHub, jadwalHub.idJadwalProfilCbt, detailPaketProgram.idPaketProgram)} 
                                        />}
                                />
                                {/* {<div className="button-group">
                                    <button className="btn btn-outline-info btn-sm" onClick={() => this.props.handleThrowPaketProgram(pp)}><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                    <button className="btn btn-outline-danger btn-sm" disabled><i className="fa fa-trash-o" aria-hidden="true"></i></button>								
                                    <button className="btn btn-outline-primary btn-sm" onClick={() => this.props.handleAddJadwal(pp)}><i className="fa fa-sliders" aria-hidden="true"></i></button>								
                                </div>} */}
                            </TableCell>
                        </TableRow>                    
                    )
                }
            </TableBody>
        )
    }
    
}
 
export default ListAllJadwalProfilCbt;